import { render, staticRenderFns } from "./reportePtiPagados.vue?vue&type=template&id=0ac8d048&scoped=true"
import script from "./reportePtiPagados.vue?vue&type=script&lang=js"
export * from "./reportePtiPagados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8d048",
  null
  
)

export default component.exports